import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button, Image } from 'react-bootstrap'
import imgDownload from '../../../images/Download_Outline.svg'
import Swal from 'sweetalert2'
import { htmlToPdfmake, pdfMake } from '../../../lib/pdf-make'
import NavContract from './contract-nav'
import { useSelector } from 'react-redux'
import moment from 'moment'
import SwalCustom from '../../../alert/swal-custom'
import {
  getContractDetailFileAPI,
  updatePDPAAPI
} from '../../../services/contract'
import Error_false from '../../error/error-false'
import { TXTSUCCESS } from '../../../Constants'

export default function ContractPDPANav({
  data,
  getContractDetail,
  isCheck4,
  signatureEMP
}) {
  const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const contractNo = searchParams.get('contractNo')
  useEffect(() => {
    moment.locale('th')
  }, [isCheck4])

  const getContractDetailFile = async () => {
    const docTypeId = 3
    const body = { orgId, contractNo, docTypeId }
    const result = await getContractDetailFileAPI(body)
    if (!result) return
    if (result.status) {
      window.open(result.result[0]?.url)
    }
  }

  const exportPDF = async (isChecked) => {
    try {
      const html = htmlToPdfmake(ContractPDPANav ? ContractPDPANav : `-`, {
        defaultStyles: {}
      })
      const file = pdfMake.createPdf({
        images: {
          imgSquare: `${window.location.origin}/image/square.png`,
          imgCheckBox: `${window.location.origin}/image/checkBox.png`,
          imgSignatureEMP:
            signatureEMP?.url || `${window.location.origin}/image/White.png`,
          imgsky:
            data.org_id === 1
              ? `${window.location.origin}/image/SKY.png`
              : data.org_id === 2
                ? `${window.location.origin}/image/MT.jpg`
                : data.org_id === 3
                  ? `${window.location.origin}/image/ASTRO.png`
                  : data.org_id === 5
                    ? `${window.location.origin}/image/ProInside.png`
                    : `${window.location.origin}/image/White.png`
        },

        info: {
          title: 'เอกสาร PDPA'
        },
        // watermark: { text: "ตัวอย่าง", opacity: 0.1 },
        header: function (cp, pc, ps) {
          //add logic
          return {
            columns: [
              {
                image: 'imgsky',
                alignment: 'left',
                width: 60,
                marginTop: 40,
                marginLeft: 40,
                marginBottom: 10
              },
              {
                text: contractNo,
                bold: true,
                opacity: 0.5,
                alignment: 'right',
                margin: [0, 20, 20, 10]
              }
            ],
            height: '100%',
            marginBottom: 5
          }
        },
        content: [
          // {
          //   image: "imgsky",
          //   alignment: "left",
          //   width: 60,
          //   marginTop: 0,
          //   marginBottom: 10,
          // },
          {
            text: 'แบบฟอร์มขอความยินยอมในการประมวลผลข้อมูลส่วนบุคคล',
            bold: true,
            alignment: 'center',
            fontSize: 12
          },

          {
            text: '(ข้อมูลตามมาตรา 26)',
            bold: false,
            alignment: 'center',

            marginBottom: 10,
            fontSize: 12
          },

          {
            text: '\t\t\t\tด้วยความเคารพต่อสิทธิในข้อมูลส่วนบุคคลของพนักงานอย่างสูงสุดและเพื่อให้ความคุ้มครองสิทธิของพนักงานเป็นไปอย่าง ถูกต้องเหมาะสมตามกฎหมายทางบริษัทขอความกรุณาขอความยินยอมจากท่าน เพื่ออนุญาตให้ทางบริษัทประมวลผลข้อมูลเพื่อ วัตถุประสงค์ต่อไปนี้',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 10
            // alignment: 'justify'
          },

          {
            stack: [
              {
                columns: [
                  {
                    text: 'กรุณาทำเครื่องหมาย / ในช่อง ',
                    bold: false,
                    preserveLeadingSpaces: true,
                    marginTop: -2
                  },
                  {
                    image: 'imgSquare',
                    width: 10,
                    marginLeft: -130
                  },
                  {
                    text: '  ด้านหน้า',
                    marginTop: -2,
                    preserveLeadingSpaces: true,
                    marginLeft: -130
                  }
                ]
              }
            ]
          },

          {
            text: '1. ในการบันทึกเวลาเข้าออกงาน ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ใบหน้า) เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลสถิติการเข้าออกงาน (SPD37: การบันทึกเวลาเข้าออกงาน)',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 10
          },

          {
            stack: [
              {
                columns: [
                  {
                    image: `${
                      data?.pdpa[0]?.is_check === 1
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },

                  {
                    image: `${
                      data?.pdpa[0]?.is_check === 0
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ไม่ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  }
                ],
                alignment: 'left',
                marginBottom: 10
              }
            ]
          },
          {
            text: '2. ในการบันทึกเวลาเข้าออกงาน ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ลายนิ้วมือ) เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลสถิติการเข้าออกงาน (SPD37: การบันทึกเวลาเข้าออกงาน)',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 10
          },

          {
            stack: [
              {
                columns: [
                  {
                    image: `${
                      data?.pdpa[1]?.is_check === 1
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },

                  {
                    image: `${
                      data?.pdpa[1]?.is_check === 0
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ไม่ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  }
                ],
                alignment: 'left',
                marginBottom: 10
              }
            ]
          },

          {
            text: '3. ในการผ่านเข้าออกพื้นที่ ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ใบหน้า) เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลการเข้าออกพื้นที่ (SPD39: การเข้าออกพื้นที่)',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 10
          },

          {
            stack: [
              {
                columns: [
                  {
                    image: `${
                      data?.pdpa[2]?.is_check === 1
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },

                  {
                    image: `${
                      data?.pdpa[2]?.is_check === 0
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ไม่ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  }
                ],
                alignment: 'left',
                marginBottom: 10
              }
            ]
          },
          {
            text: '4.	ในการผ่านเข้าออกพื้นที่ ท่านยินยอมให้ทางบริษัทประมวลผลข้อมูลชีวมิติ (ลายนิ้วมือ) เพื่อวัตถุประสงค์ในการที่ทางบริษัทจะนำข้อมูลดังกล่าวไปอำนวยความสะดวกในการประมวลผลการเข้าออกพื้นที่ (SPD39: การเข้าออกพื้นที่)',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 10
          },

          {
            stack: [
              {
                columns: [
                  {
                    image: `${
                      data?.pdpa[3]?.is_check === 1
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },

                  {
                    image: `${
                      data?.pdpa[3]?.is_check === 0
                        ? 'imgCheckBox'
                        : 'imgSquare'
                    }`,
                    width: 10
                  },
                  {
                    text: '  ไม่ยินยอม',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  }
                ],
                alignment: 'left',
                marginBottom: 10
              }
            ]
          },
          {
            text: '\t\t\t\tโปรดทำความเข้าใจว่าการไม่ยินยอมให้ทางบริษัทประมวลผลข้อมูลดังกล่าวไม่มีผลต่อสัญญาหลักแต่ประการใด ทางบริษัท จะดูแลรักษาข้อมูลของท่านด้วยความปลอดภัยขั้นสูงสุด และจะประมวลผลรักษาข้อมูลของท่านไว้ตามระยะเวลาที่กำหนด และจะทำ การลบข้อมูลทันทีหลังจากนั้น โดยท่านสามารถอ่านรายละเอียดเพิ่มเติมได้ที่ “นโยบายคุ้มครองข้อมูลส่วนบุคคลสำหรับบุคลากรและ ผู้สมัครงาน” หรือ บน website https://www.skyict.co.th/privacy-policy',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 10,
            alignment: 'justify'
          },
          {
            text: '\t\t\t\tทางบริษัทยังยินดีที่จะเรียนให้ท่านทราบว่า ความยินยอมดังกล่าวนี้สามารถเพิกถอนได้ทุกเมื่อ ทางบริษัทมีระบบที่พร้อมจะ ดำเนินการลบข้อมูลที่ท่านได้ให้ไว้เพื่ออำนวยความสะดวกให้แก่ท่าน โดยท่านเพียงแจ้งความจำนงมาที่ DPO@skyict.co.th นอกจากนี้ เมื่อไรก็ตามที่ทางบริษัทจะมีการเปลี่ยนแปลงหรือเพิ่มเติมวัตถุประสงค์ใด ๆ ทางบริษัทจะแจ้งให้ท่านทราบ และขอความยินยอมจาก ท่านเป็นรายกรณีก่อนเสมอ',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 15,
            pageBreak: 'before',
            marginTop: 40,
            alignment: 'justify'
          },
          {
            text: 'ข้าพเจ้ารับทราบข้อมูลดังกล่าวและลงชื่อเพื่อยืนยันการแสดงความยินยอมตามที่ได้เลือกไว้',
            bold: false,
            preserveLeadingSpaces: true,
            marginBottom: 10
          },
          {
            columns: [
              {
                text: '.',
                bold: false,
                alignment: 'left',
                preserveLeadingSpaces: true,
                width: 250,
                marginTop: 20,
                color: 'white'
              },

              {
                stack: [
                  {
                    image: 'imgSignatureEMP',
                    width: 150,
                    alignment: 'center',
                    marginTop: 15,
                    marginBottom: -15
                  },
                  {
                    text: 'ลงชื่อ .....................................................ลูกจ้าง',
                    alignment: 'center',
                    marginTop: 5
                  },

                  {
                    text: `( ${signatureEMP?.title_th || '               '} ${
                      signatureEMP?.name_th || '               '
                    } ${signatureEMP?.surname_th || '               '} )`,
                    bold: false,
                    alignment: 'center',
                    preserveLeadingSpaces: true,
                    marginTop: 2
                  }
                ]
              }
            ]
          }
        ],
        footer: function (cp, pc, ps) {
          //add logic
          return {
            columns: [
              [
                {
                  canvas: [
                    {
                      type: 'line',
                      x1: 0,
                      y1: 0,
                      x2: 500,
                      y2: 0,
                      margin: [30, 10, 30, 20],
                      lineWidth: 0.2,
                      lineColor: 'black'
                    }
                  ],
                  marginTop: -20,
                  marginBottom: 30,
                  alignment: 'center'
                },

                {
                  text: ` ${cp} of ${pc}`,
                  alignment: 'center',
                  bold: true,
                  // margin: [40, 20, 40, 10],
                  marginBottom: -38,
                  fontSize: 8
                },
                {
                  text:
                    data.org_th +
                    ' ' +
                    data.address1_th +
                    ' ' +
                    data.address2_th +
                    ' ' +
                    'เบอร์โทร' +
                    ' ' +
                    data.fax_no +
                    '                                                                                      ' +
                    data.org_en +
                    ' ' +
                    data.address1_en +
                    ' ' +
                    data.address2_en +
                    ' ' +
                    'Fax : ' +
                    ' ' +
                    data.fax_no,
                  color: '#464EA4',
                  fontSize: 7,
                  alignment: 'left',
                  margin: [30, -5, 30, 90],
                  lineHeight: 1.2
                }
              ]
            ],
            widths: ['*', 100]
          }
        },

        pageSize: 'A4',
        defaultStyle: {
          fontSize: 10,
          bold: false,
          font: 'THSarabunNew',
          color: '#2A2A2A',
          // alignment: 'justify',
          lineHeight: 1.7
        },
        pageMargins: [40, 50, 40, 30] //ซ้าย บน ขวา ล่าง
      })
      if (isChecked === 1) {
        file.getBlob((blob) => {
          onSubmitEdit(blob)
        })
      } else {
        file.open()
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Fail!',
        text: error,
        customClass: {
          confirmButton: 'btn btn-success'
        }
      })
    }
  }

  const onSubmitEdit = (file) => {
    var formData = new FormData()
    formData.append('orgId', orgId)
    formData.append('file', file)
    formData.append('contractNo', contractNo)

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to confirm?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        updateContractConfirm(formData)
      }
    })
  }

  const updateContractConfirm = async (param) => {
    const datas = await updatePDPAAPI(param)
    if (!datas) return
    if (datas.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getContractDetail()
      })
    } else {
      Error_false(datas)
    }
  }
  return (
    <>
      <div
        className="p-3 d-flex d-flex justify-content-between bg-white"
        style={{ position: 'sticky', top: '0px' }}
      >
        <span className=" d-flex gap-3  rounded-top pointer-event">
          <NavContract />
        </span>

        <div className="gap-3 d-flex ">
          {isCheck4 === 1 ? (
            <>
              <Button
                size="sm"
                style={{ maxHeight: '33px' }}
                onClick={() => getContractDetailFile()}
              >
                <Image
                  style={{
                    width: '10px',
                    marginRight: 5
                  }}
                  className="mb-1 "
                  src={imgDownload}
                />
                Download PDF
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="outline-secondary"
                style={{ maxHeight: '33px' }}
                size="sm"
                onClick={() => {
                  exportPDF(1)
                }}
              >
                Confirm
              </Button>
              <Button
                onClick={() => {
                  exportPDF(2)
                }}
                size="sm"
                style={{ maxHeight: '33px' }}
              >
                <Image
                  style={{
                    width: '10px',
                    marginRight: 5
                  }}
                  className="mb-1 "
                  src={imgDownload}
                />
                Download PDF
              </Button>
            </>
          )}
        </div>
      </div>
    </>
  )
}
